import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const GET_HAS_CUSTOMER_ACCOUNT = gql(`
  query getHasCustomerAccount($organizationSlug: String!) {
    organization(organizationSlug: $organizationSlug){
      __typename
      ... on Organization {
        id
        hasCustomerAccount
      }
    }
  }
`);
interface Props {
  organizationSlug: string;
  skip?: boolean;
}

export const useHasCustomerAccount = ({ organizationSlug, skip }: Props) =>
  useQuery(GET_HAS_CUSTOMER_ACCOUNT, {
    variables: { organizationSlug },
    skip: !organizationSlug || skip
  });
